/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * ChatAgent.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangeMemberRoleRequest,
  CreateWorkspaceRequest,
  DeleteApiWorkspacesWorkspaceIdParams,
  DeleteWorkspaceRequest,
  InviteMemberRequest,
  UpdateWorkspaceRequest
} from '.././model';

import { customInstance } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getApiWorkspaces = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiWorkspacesQueryKey = () => {
    return [
    `/api/workspaces`
    ] as const;
    }

    
export const getGetApiWorkspacesQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspaces>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaces>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspaces>>> = ({ signal }) => getApiWorkspaces(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspaces>>>
export type GetApiWorkspacesQueryError = unknown


export function useGetApiWorkspaces<TData = Awaited<ReturnType<typeof getApiWorkspaces>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspaces<TData = Awaited<ReturnType<typeof getApiWorkspaces>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspaces<TData = Awaited<ReturnType<typeof getApiWorkspaces>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaces>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspaces<TData = Awaited<ReturnType<typeof getApiWorkspaces>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspaces>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiWorkspaces = (
    createWorkspaceRequest: CreateWorkspaceRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorkspaceRequest, signal
    },
      options);
    }
  


export const getPostApiWorkspacesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaces>>, TError,{data: CreateWorkspaceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaces>>, TError,{data: CreateWorkspaceRequest}, TContext> => {

const mutationKey = ['postApiWorkspaces'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspaces>>, {data: CreateWorkspaceRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiWorkspaces(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspacesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspaces>>>
    export type PostApiWorkspacesMutationBody = CreateWorkspaceRequest
    export type PostApiWorkspacesMutationError = unknown

    export const usePostApiWorkspaces = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspaces>>, TError,{data: CreateWorkspaceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspaces>>,
        TError,
        {data: CreateWorkspaceRequest},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspacesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const patchApiWorkspacesWorkspaceId = (
    workspaceId: string,
    updateWorkspaceRequest: UpdateWorkspaceRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkspaceRequest
    },
      options);
    }
  


export const getPatchApiWorkspacesWorkspaceIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceId>>, TError,{workspaceId: string;data: UpdateWorkspaceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceId>>, TError,{workspaceId: string;data: UpdateWorkspaceRequest}, TContext> => {

const mutationKey = ['patchApiWorkspacesWorkspaceId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceId>>, {workspaceId: string;data: UpdateWorkspaceRequest}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  patchApiWorkspacesWorkspaceId(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiWorkspacesWorkspaceIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceId>>>
    export type PatchApiWorkspacesWorkspaceIdMutationBody = UpdateWorkspaceRequest
    export type PatchApiWorkspacesWorkspaceIdMutationError = unknown

    export const usePatchApiWorkspacesWorkspaceId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceId>>, TError,{workspaceId: string;data: UpdateWorkspaceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiWorkspacesWorkspaceId>>,
        TError,
        {workspaceId: string;data: UpdateWorkspaceRequest},
        TContext
      > => {

      const mutationOptions = getPatchApiWorkspacesWorkspaceIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteApiWorkspacesWorkspaceId = (
    workspaceId: string,
    deleteWorkspaceRequest: DeleteWorkspaceRequest,
    params?: DeleteApiWorkspacesWorkspaceIdParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteWorkspaceRequest,
        params
    },
      options);
    }
  


export const getDeleteApiWorkspacesWorkspaceIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceId>>, TError,{workspaceId: string;data: DeleteWorkspaceRequest;params?: DeleteApiWorkspacesWorkspaceIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceId>>, TError,{workspaceId: string;data: DeleteWorkspaceRequest;params?: DeleteApiWorkspacesWorkspaceIdParams}, TContext> => {

const mutationKey = ['deleteApiWorkspacesWorkspaceId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceId>>, {workspaceId: string;data: DeleteWorkspaceRequest;params?: DeleteApiWorkspacesWorkspaceIdParams}> = (props) => {
          const {workspaceId,data,params} = props ?? {};

          return  deleteApiWorkspacesWorkspaceId(workspaceId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkspacesWorkspaceIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceId>>>
    export type DeleteApiWorkspacesWorkspaceIdMutationBody = DeleteWorkspaceRequest
    export type DeleteApiWorkspacesWorkspaceIdMutationError = unknown

    export const useDeleteApiWorkspacesWorkspaceId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceId>>, TError,{workspaceId: string;data: DeleteWorkspaceRequest;params?: DeleteApiWorkspacesWorkspaceIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceId>>,
        TError,
        {workspaceId: string;data: DeleteWorkspaceRequest;params?: DeleteApiWorkspacesWorkspaceIdParams},
        TContext
      > => {

      const mutationOptions = getDeleteApiWorkspacesWorkspaceIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiWorkspacesWorkspaceIdMembers = (
    workspaceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/members`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdMembersQueryKey = (workspaceId?: string,) => {
    return [
    `/api/workspaces/${workspaceId}/members`
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdMembersQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdMembersQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>> = ({ signal }) => getApiWorkspacesWorkspaceIdMembers(workspaceId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>>
export type GetApiWorkspacesWorkspaceIdMembersQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdMembers<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdMembers<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdMembers<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdMembers<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdMembersQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiWorkspacesWorkspaceIdInvitations = (
    workspaceId: string,
    inviteMemberRequest: InviteMemberRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/invitations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteMemberRequest, signal
    },
      options);
    }
  


export const getPostApiWorkspacesWorkspaceIdInvitationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdInvitations>>, TError,{workspaceId: string;data: InviteMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdInvitations>>, TError,{workspaceId: string;data: InviteMemberRequest}, TContext> => {

const mutationKey = ['postApiWorkspacesWorkspaceIdInvitations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdInvitations>>, {workspaceId: string;data: InviteMemberRequest}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  postApiWorkspacesWorkspaceIdInvitations(workspaceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspacesWorkspaceIdInvitationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdInvitations>>>
    export type PostApiWorkspacesWorkspaceIdInvitationsMutationBody = InviteMemberRequest
    export type PostApiWorkspacesWorkspaceIdInvitationsMutationError = unknown

    export const usePostApiWorkspacesWorkspaceIdInvitations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdInvitations>>, TError,{workspaceId: string;data: InviteMemberRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdInvitations>>,
        TError,
        {workspaceId: string;data: InviteMemberRequest},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspacesWorkspaceIdInvitationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteApiWorkspacesWorkspaceIdInvitationsInvitationId = (
    workspaceId: string,
    invitationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/invitations/${invitationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApiWorkspacesWorkspaceIdInvitationsInvitationIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdInvitationsInvitationId>>, TError,{workspaceId: string;invitationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdInvitationsInvitationId>>, TError,{workspaceId: string;invitationId: string}, TContext> => {

const mutationKey = ['deleteApiWorkspacesWorkspaceIdInvitationsInvitationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdInvitationsInvitationId>>, {workspaceId: string;invitationId: string}> = (props) => {
          const {workspaceId,invitationId} = props ?? {};

          return  deleteApiWorkspacesWorkspaceIdInvitationsInvitationId(workspaceId,invitationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkspacesWorkspaceIdInvitationsInvitationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdInvitationsInvitationId>>>
    
    export type DeleteApiWorkspacesWorkspaceIdInvitationsInvitationIdMutationError = unknown

    export const useDeleteApiWorkspacesWorkspaceIdInvitationsInvitationId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdInvitationsInvitationId>>, TError,{workspaceId: string;invitationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdInvitationsInvitationId>>,
        TError,
        {workspaceId: string;invitationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiWorkspacesWorkspaceIdInvitationsInvitationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteApiWorkspacesWorkspaceIdMembersUserId = (
    workspaceId: string,
    userId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/members/${userId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApiWorkspacesWorkspaceIdMembersUserIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdMembersUserId>>, TError,{workspaceId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdMembersUserId>>, TError,{workspaceId: string;userId: string}, TContext> => {

const mutationKey = ['deleteApiWorkspacesWorkspaceIdMembersUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdMembersUserId>>, {workspaceId: string;userId: string}> = (props) => {
          const {workspaceId,userId} = props ?? {};

          return  deleteApiWorkspacesWorkspaceIdMembersUserId(workspaceId,userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkspacesWorkspaceIdMembersUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdMembersUserId>>>
    
    export type DeleteApiWorkspacesWorkspaceIdMembersUserIdMutationError = unknown

    export const useDeleteApiWorkspacesWorkspaceIdMembersUserId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdMembersUserId>>, TError,{workspaceId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdMembersUserId>>,
        TError,
        {workspaceId: string;userId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiWorkspacesWorkspaceIdMembersUserIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putApiWorkspacesWorkspaceIdMembersUserIdRole = (
    workspaceId: string,
    userId: string,
    changeMemberRoleRequest: ChangeMemberRoleRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/members/${userId}/role`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeMemberRoleRequest
    },
      options);
    }
  


export const getPutApiWorkspacesWorkspaceIdMembersUserIdRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdMembersUserIdRole>>, TError,{workspaceId: string;userId: string;data: ChangeMemberRoleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdMembersUserIdRole>>, TError,{workspaceId: string;userId: string;data: ChangeMemberRoleRequest}, TContext> => {

const mutationKey = ['putApiWorkspacesWorkspaceIdMembersUserIdRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdMembersUserIdRole>>, {workspaceId: string;userId: string;data: ChangeMemberRoleRequest}> = (props) => {
          const {workspaceId,userId,data} = props ?? {};

          return  putApiWorkspacesWorkspaceIdMembersUserIdRole(workspaceId,userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiWorkspacesWorkspaceIdMembersUserIdRoleMutationResult = NonNullable<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdMembersUserIdRole>>>
    export type PutApiWorkspacesWorkspaceIdMembersUserIdRoleMutationBody = ChangeMemberRoleRequest
    export type PutApiWorkspacesWorkspaceIdMembersUserIdRoleMutationError = unknown

    export const usePutApiWorkspacesWorkspaceIdMembersUserIdRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdMembersUserIdRole>>, TError,{workspaceId: string;userId: string;data: ChangeMemberRoleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdMembersUserIdRole>>,
        TError,
        {workspaceId: string;userId: string;data: ChangeMemberRoleRequest},
        TContext
      > => {

      const mutationOptions = getPutApiWorkspacesWorkspaceIdMembersUserIdRoleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiInvitationsToken = (
    token: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/invitations/${token}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiInvitationsTokenQueryKey = (token?: string,) => {
    return [
    `/api/invitations/${token}`
    ] as const;
    }

    
export const getGetApiInvitationsTokenQueryOptions = <TData = Awaited<ReturnType<typeof getApiInvitationsToken>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInvitationsToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiInvitationsTokenQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInvitationsToken>>> = ({ signal }) => getApiInvitationsToken(token, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiInvitationsToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiInvitationsTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getApiInvitationsToken>>>
export type GetApiInvitationsTokenQueryError = unknown


export function useGetApiInvitationsToken<TData = Awaited<ReturnType<typeof getApiInvitationsToken>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInvitationsToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInvitationsToken>>,
          TError,
          Awaited<ReturnType<typeof getApiInvitationsToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiInvitationsToken<TData = Awaited<ReturnType<typeof getApiInvitationsToken>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInvitationsToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInvitationsToken>>,
          TError,
          Awaited<ReturnType<typeof getApiInvitationsToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiInvitationsToken<TData = Awaited<ReturnType<typeof getApiInvitationsToken>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInvitationsToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiInvitationsToken<TData = Awaited<ReturnType<typeof getApiInvitationsToken>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiInvitationsToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiInvitationsTokenQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiInvitationsTokenAccept = (
    token: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/invitations/${token}/accept`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiInvitationsTokenAcceptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiInvitationsTokenAccept>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiInvitationsTokenAccept>>, TError,{token: string}, TContext> => {

const mutationKey = ['postApiInvitationsTokenAccept'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiInvitationsTokenAccept>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  postApiInvitationsTokenAccept(token,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiInvitationsTokenAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof postApiInvitationsTokenAccept>>>
    
    export type PostApiInvitationsTokenAcceptMutationError = unknown

    export const usePostApiInvitationsTokenAccept = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiInvitationsTokenAccept>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiInvitationsTokenAccept>>,
        TError,
        {token: string},
        TContext
      > => {

      const mutationOptions = getPostApiInvitationsTokenAcceptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    